import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { NavLink } from 'app/components/core/NavLink';

export const UnloadSnowflakeTableFailureNotification = ({ id, onDismiss, i18nKey, jobRunUid }) => (
    <Snackbar onDismiss={onDismiss} id={id} variant={SnackbarVariant.ERROR}>
        <SnackbarMessage>
            <Trans
                i18nKey={i18nKey}
                values={{ jobRunUid }}
                components={{
                    navLink: <NavLink to={`jobs/dashboard?selected=${jobRunUid}`} />
                }}
            />
        </SnackbarMessage>
    </Snackbar>
);

UnloadSnowflakeTableFailureNotification.propTypes = {
    id: PropTypes.string.isRequired,
    i18nKey: PropTypes.string.isRequired,
    jobRunUid: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired
};
